import { parseInboundPayload } from '../inbound';
import { createArrayWithBracesParser, numberParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
import { playerMedalsParser } from './utils/medalInboundUtils';
import { playerStyleStringParser } from './utils/playerStyleInboundUtils';
export const UPDATE_PLAYER_MEDALS_AND_STYLE_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'updatedPlayersMedalsAndStyle', parser: createArrayWithBracesParser(updatedPlayerMedalsAndStyleParser) }
    ]
};
function updatedPlayerMedalsAndStyleParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, updatedPlayerMedalsAndStylePartDefinitions);
}
const updatedPlayerMedalsAndStylePartDefinitions = [
    { name: 'playerId', parser: numberParser },
    { name: 'medals', parser: playerMedalsParser },
    { name: 'style', parser: playerStyleStringParser }
];
